import React__default from 'react';
import { truncate } from 'lodash';
import MessageBubble from '../../MessageBubble/index.js';
import MessageBubbleText from '../../MessageBubbleText/index.js';
import { ConsumerRichCardEvents } from '../../../containers/RichCardEventEmitter/ConsumerEventData/index.js';
import { useRichCardEventEmitter } from '../../../containers/RichCardEventEmitter/index.js';
import { newExpertCuratedOrderRichCard } from '../../../services/richCardFactory.js';
import HeroWithImage from '../components/HeroWithImage/index.js';
import CallToAction from '../components/CallToAction/index.js';
import { formatMonetaryAmountAsJsx } from '../../../services/money.js';
import { ServiceCurationMessageComponent } from './ServiceCurationMessage.generated.js';
import styles from './styles.css.js';

var ServiceCurationMessage = function ServiceCurationMessage(_a) {
  var message = _a.message,
      myself = _a.myself;
  var richCardEventEmitter = useRichCardEventEmitter();
  var richCard = newExpertCuratedOrderRichCard(message);
  return React__default.createElement(ServiceCurationMessageComponent, {
    variables: {
      id: richCard.expertCuratedOrderId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.expertCuratedOrder) {
      var image = data.expertCuratedOrder.order.primaryImage;
      var activeVariations = data.expertCuratedOrder.variationOptions.filter(function (variation) {
        return variation.enabled;
      });
      var title = activeVariations[0].sellable.title;
      var description = activeVariations[0].sellable.descriptionText;
      return React__default.createElement(MessageBubble, {
        message: message
      }, React__default.createElement(HeroWithImage, {
        imageUrl: image === null || image === void 0 ? void 0 : image.url
      }), React__default.createElement("div", {
        className: styles.content
      }, React__default.createElement("div", {
        className: styles.sellableTitle
      }, title), description && React__default.createElement("div", {
        className: styles.description
      }, truncate(description, {
        length: 150
      })), React__default.createElement("div", {
        className: styles.variations
      }, activeVariations.map(function (variation) {
        return React__default.createElement("div", {
          key: variation.sellable.id,
          className: styles.variant
        }, variation.sellable.variants[0] && React__default.createElement("div", {
          className: styles.duration
        }, variation.sellable.variants[0].displayValueHtml), React__default.createElement("div", {
          className: styles.price
        }, formatMonetaryAmountAsJsx(variation.price, {
          round: true
        })));
      }))), React__default.createElement(CallToAction, {
        onClick: function onClick() {
          return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: ConsumerRichCardEvents.VIEW_EXPERIENCE_ORDER,
            orderId: richCard.expertCuratedOrderId
          });
        }
      }, "View Order Details"));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading messages!");
    }
  });
};

ServiceCurationMessage.handlesMessage = function (message) {
  return !!newExpertCuratedOrderRichCard(message);
};

export default ServiceCurationMessage;
//# sourceMappingURL=index.js.map
